// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AimOutlinedSvg from "@ant-design/icons-svg/es/asn/AimOutlined";
import AntdIcon from '../components/AntdIcon';

var AimOutlined = function AimOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AimOutlinedSvg
  }));
};

AimOutlined.displayName = 'AimOutlined';
export default React.forwardRef(AimOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AimOutlined.js
// module id = 527
// module chunks = 0